import { useMemo } from 'react';

import { GroupedFilters } from './useGroupFilters';

// this hook is used to convert the grouped filters to a string array that can be used in the search api

export const useMakeAdvancedFiltersToString = (
  groupedFilters: GroupedFilters[],
) => {
  const filtersStringArray = useMemo(
    () =>
      groupedFilters.map((filter) => {
        const { platformSlug, filterType, valueLowerCase, criteria } = filter;
        const criteriaValue = criteria ? (criteria as number) / 100 : 0;
        return `${platformSlug.toLowerCase()}.${filterType}:${valueLowerCase}:${criteriaValue}`;
      }),
    [groupedFilters],
  );

  return filtersStringArray;
};
